import * as React from 'react';

import FullscreenLoadingComponent from "./components/FullscreenLoadingComponent/FullscreenLoadingComponent";
import TopLevelRouterContainer from "./containers/TopLevelRouterContainer";

import {Provider} from "react-redux";
import {applyMiddleware, combineReducers, createStore} from "redux";
import {persistReducer, persistStore} from "redux-persist";
import {PersistGate} from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';
import thunk from "redux-thunk";
import {CredentialReducer, IOReducer, LiteratureWizardReducer, NotificationReducer} from './reducers';

import {setDefaultLanguage, setTranslations} from 'react-multi-lang';
import * as WebFont from 'webfontloader';
import de from './localisation/de.json';
import en from './localisation/en.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import './index.css';

setTranslations({de, en});

const langString = navigator.language || (navigator as any).userLanguage;
const lang = langString.split(/[_-]/)[0].toLowerCase();

if (lang === "de") {
    setDefaultLanguage('de');
} else {
    setDefaultLanguage('en');
}

WebFont.load({
    google: {
        families: ['Roboto:300,400', 'sans-serif']
    }
});

/**
 * Combine reducers to a single object
 * @type {Reducer<any>}
 */
const reducers = combineReducers({
    credentials: CredentialReducer,
    io: IOReducer,
    literature: LiteratureWizardReducer,
    notification: NotificationReducer,
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['credentials'],
};

const persistedReducers = persistReducer(persistConfig, reducers);

/**
 * Create store and apply middleware
 * @type {Store<any & any, Action> & {dispatch: ThunkDispatch<any, E, Action> & any}}
 */
const store = createStore(persistedReducers, applyMiddleware(thunk));
const persistor = persistStore(store);

/**
 * Top level literature wizard app class
 */
class App extends React.PureComponent {
    /**
     * Render view
     * @returns {any}
     */
    public render() {
        return (
            <Provider store={store}>
                <PersistGate persistor={persistor} loading={<FullscreenLoadingComponent/>}>
                    <TopLevelRouterContainer/>
                </PersistGate>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/LiteratureWizard.tsx